import { PermissionsType } from '@/common/permissionsConst';
import OperationAnalysisReport from '.';

const routes = [
  {
    path: '/operation/analysis/report',
    permission: PermissionsType.P_OPERATIONS_ANALYSIS_REPORT,
    element: <OperationAnalysisReport />,
  },
];

export default routes;
